import React, { useMemo, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';
import useIntersectionObserver from '@react-hook/intersection-observer';

const id = 'midinning-video-ad';
const slug = 'c-2523586283';
const playerConfigOverride = { eVar184: 'Unspecified' };
const EMPTY = Object.freeze({});

const playbacks = [
    {
        name: 'mp4Avc',
        url: 'https://cuts.diamond.mlb.com/FORGE/2020/2020-05/27/a9ee6a3c-cca228ec-5fe8e91b-csvm-diamondx64-asset_1280x720_59_4000K.mp4'
    },
    {
        name: 'hlsCloud',
        url: 'https://cuts.diamond.mlb.com/FORGE/2020/2020-05/27/a9ee6a3c-cca228ec-5fe8e91b-csvm-diamondx64-asset.m3u8'
    },
    {
        name: 'highBit',
        url: 'https://cuts.diamond.mlb.com/FORGE/2020/2020-05/27/a9ee6a3c-cca228ec-5fe8e91b-csvm-diamondx64-asset_1280x720_59_16000K.mp4'
    }
];
const templateUrl = 'https://img.mlbstatic.com/mlb-images/image/private/{formatInstructions}/mlb/juuua0ha2ir1rkr7yoid';

const options = {
    threshold: 0.3,
    initialIsIntersecting: true
};

const VideoAd = ({
    midInningAdConfig = EMPTY,
    adComplete
}) => {
    const adRef = useRef(null);
    const { isIntersecting } = useIntersectionObserver(adRef, options);
    const [playerWrapper, setPlayerWrapper] = useState(null);
    const handlers = useMemo(() => {
        return {
            adComplete
        };
    }, [adComplete]);

    const videoSlug = midInningAdConfig?.slug || slug;
    const videoPlaybacks = midInningAdConfig?.playbacks || playbacks;
    const videoTemplateUrl = midInningAdConfig?.templateUrl || templateUrl;

    useEffect(() => {
        if (playerWrapper) {
            const { mediaPlayer } = playerWrapper;
            const dfpPlugin = mediaPlayer?.pluginManager?.getPlugin('DfpPlugin');

            if (dfpPlugin) {
                if (!isIntersecting) {
                    dfpPlugin.pause();
                } else {
                    dfpPlugin.resume();
                }
            }
        }
    }, [isIntersecting, playerWrapper]);

    return (
        <div id={id} ref={adRef}>
            <VideoPlayer
                title={'Gameday Video Placement clip'}
                duration={'00:00:01'}
                playbackContainerId={id}
                id={videoSlug}
                showMetaInfo={false}
                templateUrl={videoTemplateUrl}
                slug={videoSlug}
                showTitle={false}
                handlers={handlers}
                width={'100%'}
                autoPlay={true}
                mute={true}
                prerollType={'midinning'}
                playbacks={videoPlaybacks}
                playerConfigOverride={playerConfigOverride}
                setPlayerWrapper={setPlayerWrapper}
            />
        </div>
    );
};

VideoAd.propTypes = {
    midInningAdConfig: PropTypes.object,
    adComplete: PropTypes.func
};

export default VideoAd;
